module.exports = __webpack_public_path__ + "img/Step-1.90b438a3.jpg";